import type { PropsWithChildren } from 'react';

import { MainContainerStyled } from './styles/MainContainerStyled'
import { type UploadCommonProps } from '../../Upload'

export interface IMainContainerProps {
  commonProps: UploadCommonProps
}

export const MainContainer = ({
  children,
}: PropsWithChildren<IMainContainerProps>) => {
  return <MainContainerStyled>{children}</MainContainerStyled>
}
